import React from 'react';
import { Link } from 'react-router-dom';
import { CLUB } from '../../utils/constants';

function StatusShell({ icon, title, children, onLogout }) {
  return (
    <div className="mt-section">
      <div className="mt-container">
        <div className="mt-card mt-status">
          <div className="mt-status__icon" aria-hidden="true">
            {icon}
          </div>
          <h1 className="mt-status__title">{title}</h1>
          {children}
          <div className="mt-row mt-status__actions">
            <Link to="/" className="mt-btn mt-btn--ghost mt-btn--sm">
              Zur Startseite
            </Link>
            {onLogout && (
              <button type="button" className="mt-btn mt-btn--ghost mt-btn--sm" onClick={onLogout}>
                Abmelden
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function Pending({ onLogout }) {
  return (
    <StatusShell icon="⏳" title="Deine Anfrage läuft" onLogout={onLogout}>
      <p>
        Danke für deine Anmeldung! Wir schauen uns jede Anfrage persönlich an - das dauert in
        der Regel ein bis zwei Tage.
      </p>
      <p>
        Sobald wir dich freigeschaltet haben, siehst du den Mitgliederbereich beim nächsten
        Aufruf automatisch. Du musst dich dafür nicht neu anmelden.
      </p>
      <p className="mt-muted">
        Fragen? Schreib uns an <a href={`mailto:${CLUB.email}`}>{CLUB.email}</a>.
      </p>
    </StatusShell>
  );
}

export function Rejected() {
  return (
    <StatusShell icon="🚧" title="Anfrage nicht bestätigt">
      <p>
        Wir konnten deine Mitgliedschaftsanfrage leider nicht bestaetigen. Das kann verschiedene
        Gründe haben - melde dich gern bei uns, wenn du denkst, dass da etwas schiefgelaufen ist.
      </p>
      <p className="mt-muted">
        Kontakt: <a href={`mailto:${CLUB.email}`}>{CLUB.email}</a>
      </p>
    </StatusShell>
  );
}

export function Blocked({ onLogout }) {
  return (
    <StatusShell icon="🔒" title="Zugang gesperrt" onLogout={onLogout}>
      <p>
        Dein Zugang zum Mitgliederbereich ist derzeit gesperrt. Bitte wende dich an das Team,
        wenn du das klären möchtest.
      </p>
      <p className="mt-muted">
        Kontakt: <a href={`mailto:${CLUB.email}`}>{CLUB.email}</a>
      </p>
    </StatusShell>
  );
}
